module.exports = __webpack_public_path__ + "img/ic_home.10716885.svg";